export enum GoogleMapMarkerType {
  PIN,
  SQUARE,
  CIRCLE,
  CIRCLE_PIN,
  IMAGE,
}
